










































// Vue
import { Vue, Component, Prop } from 'vue-property-decorator'

// models
import { EmployeeModel, DeviceModel } from '@/models/config'
import { PropOptionSelect } from '@/models'

// components
import { Select2, Input } from '@/components/form'
import { Loading } from '@/components'

// services
import { DeviceService, EmployeeService } from '@/services/config'

// utils
import { loading, alerts } from '@/utils'

@Component({
    name: 'FormUpdateDeviceEmployee',
    components: {
        Select2,
        Input,
        Loading
    }
})
export default class FormUpdateDeviceEmployee extends Vue {
    @Prop({ required: true }) employee!: EmployeeModel

    devices: DeviceModel[] = []
    devicesSelected: number[] = []
    password = '1234'
    name = ''
    isLoading = false

    created () {
        this.getDevices()
        this.name = this.employee.name
    }

    async save () {
        loading('show')
        const devicesId = this.devicesSelected.map(id => {
            return parseInt(String(id))
        })
        const form = {
            devices: devicesId,
            name: this.name,
            password: parseInt(this.password)
        }
        const res = await EmployeeService.updateDevices(Number(this.employee.id), form)
        if (res.error) {
            alerts.error(res.msg)
        } else {
            alerts.success()
            this.$emit('save-success')
        }
        loading('hide')
    }

    async getDevices () {
        this.isLoading = true
        this.devices = await DeviceService.getAllActivedAndConnected()
        this.getInfoDeviceOfEmployee()
    }

    async getInfoDeviceOfEmployee () {
        const info = await EmployeeService.getInfoDevices(Number(this.employee.id))
        if (info && info.length > 0) {
            this.password = info[0].password
            this.name = info[0].name
            this.devicesSelected = info.map(i => {
                return i.device_id
            })
        }
        this.isLoading = false
    }

    get opDevices (): PropOptionSelect[] {
        return this.devices.map(device => {
            return {
                value: device.id,
                text: device.name
            }
        })
    }
}
